function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h16v16H0z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.25 4.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm0 5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm0 5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM5 2h10a1 1 0 110 2H5a1 1 0 010-2zm0 5h10a1 1 0 110 2H5a1 1 0 010-2zm0 5h10a1 1 0 110 2H5a1 1 0 110-2z",
  fill: "#4F566B"
})));